import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// All modules are registered dynamically, therefore the store is initially empty
export default new Vuex.Store({})
